import { jsx as _jsx } from "react/jsx-runtime";
import BrandNotices from "@/components/Brand/Notices";
import { withBrandLayout } from "@/modules/lab/components/BrandLayout";
const BrandNoticePage = (param)=>{
    let { author , labDataResult  } = param;
    return /*#__PURE__*/ _jsx(BrandNotices, {});
};
export var __N_SSP = true;
export default withBrandLayout(BrandNoticePage);
